export function formatInbreedingCoefficient(value: number) : string | number{
    if (value){
        return Math.round(value).toString();
    }

    return "-";
}